import type { Analytics } from "@models/analytics.model";
import LineChart from "./LineChart";

export default function StudentsConversion({ analytics }: { analytics: Analytics }) {
    const rows = analytics.charts?.["conv-cumulative"] ?? [];
    return <LineChart title="Conversions Over Time" rows={rows} valueKey="conversions" seriesName="Students" curve="straight" />;
}
